import {z} from "zod";

export const reportTwoFormSchema = z.object({
	dateFrom: z.string(),
	dateTo: z.string(),
	managerIds: z.array(z.string())
});

export type ReportTwoFormType = z.infer<typeof reportTwoFormSchema>;

export const reportTwoSchema = z.object({
	dateRangeValue: z.object({
		from: z.string().optional(),
		to: z.string().optional()
	}),
	managerIds: z.array(z.string()).optional()
});

export type ReportTwoType = z.infer<typeof reportTwoSchema>;
